// @ts-check
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '../../../../../../../core/Icon';
var useStyles = makeStyles({
  root: {
    '&:hover': {
      '& $icon': {
        display: 'inline-block'
      }
    }
  },
  icon: {
    display: 'none',
    fontSize: 14
  }
}, {
  name: 'ECStylesGroup'
});

var StylesGroup = function StylesGroup(_ref) {
  var label = _ref.label,
      children = _ref.children,
      onClearStyles = _ref.onClearStyles;
  var classes = useStyles({});
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    gutterBottom: true
  }, label)), React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, {
    type: "erase",
    buttonSize: "small",
    onClick: function onClick() {
      return onClearStyles();
    },
    className: classes.icon
  }))), children);
};

export default StylesGroup;